<template>
  <div>
    <div v-if="disableList">
        <v-btn   
          icon
          large
          color="black"
          title="Settings"
          :ripple="false"
          class="mx-3"
          :to="defaultLink"
          >
          <v-icon large :color="theme.footerIconColor">mdi-cog</v-icon>
        </v-btn>
    </div>
    <v-menu v-else class="HLAppBar" min-width="200" :offset-y="true">
      <template v-slot:activator="{ on, attrs }">
        <v-btn   
          icon
          large
          color="black"
          title="Settings"
          :ripple="false"
          class="mx-3"
          v-bind="attrs"
          v-on="on"
          >
          <v-icon :color="theme.footerIconColor">mdi-cog</v-icon>
          <!--<img src="/img/logos/person_circle.png" height="40"/>-->
          <!-- Notification badge -->
          <v-badge v-if="notificationCount"
            
            :color="theme.espotoPurple"
            text-color="white"
            :content="notificationCount"
            offset-y="-3px"
            offset-x="12px"
          ></v-badge>
        </v-btn>
      </template>

      <v-list class="HLMenuBar">
        <v-list-item
          v-for="(item, index) in value"
          :key="index"
          :to="item.link"
          :ripple="false"
          :class="{small:item.divider}"
        >
          <v-divider v-if="item.divider"/>
          <v-list-item-title v-else >
            <HLTextWithBadge :title="item.title" :badge="item.badge" :color="theme.espotoPurple"/>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import HLTextWithBadge from '@/components/ui/HLTextWithBadge.vue'
import {layoutMixin} from '@/utils/layout-mixin'
import {settingsMixin} from '@/utils/settings-mixin'

  export default {
    components:{HLTextWithBadge},
    mixins: [layoutMixin,settingsMixin],
    props:{
      value:{
        type:Array
      },
      notificationCount:{
        type:Number,
        default:0
      },
      disableList:{
        type:Boolean,
        default:false
      },
      defaultLink:{
        type:String,
        default:null
      }
    },
    watch:{
      value(val){
        this.visible=val;
      }
    },
    data: () => ({
      visible:false,
      mode: '',
      timeout: 5000,
    }),
    computed:{
    },
    methods:{
      show(){
      }
    }
  }
</script>

<style scoped>
.small{
  min-height:10px;
}
</style>
